import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

// Custom DateAdapter that formats dates to show only month and day
@Injectable()
export class MonthDayDateAdapter extends NativeDateAdapter {
  override format(date: Date): string {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${monthNames[date.getMonth()]} ${date.getDate()}`;
  }
}

// Custom date format to display only month and day (no year)
export const MONTH_DAY_FORMAT = {
  parse: {
    dateInput: 'MMMM D',
  },
  display: {
    dateInput: 'input',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MMMM D',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
